export const THIRTY_SECONDS = 30 * 1000
export const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
